'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselSliderContextProvider: function() {
        return CarouselSliderContextProvider;
    },
    carouselSliderContextDefaultValue: function() {
        return carouselSliderContextDefaultValue;
    },
    useCarouselSliderContext: function() {
        return useCarouselSliderContext;
    },
    useCarouselSliderContextValues_unstable: function() {
        return useCarouselSliderContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const carouselSliderContext = /*#__PURE__*/ _react.createContext(undefined);
const carouselSliderContextDefaultValue = {
    cardFocus: false
};
const useCarouselSliderContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(carouselSliderContext)) !== null && _React_useContext !== void 0 ? _React_useContext : carouselSliderContextDefaultValue;
};
const CarouselSliderContextProvider = carouselSliderContext.Provider;
function useCarouselSliderContextValues_unstable(state) {
    const { cardFocus } = state;
    const carouselSlider = _react.useMemo(()=>({
            cardFocus
        }), [
        cardFocus
    ]);
    return {
        carouselSlider
    };
}
